import {defineAction} from 'redux-define';
import {createAction, handleActions} from 'redux-actions';
import get from 'lodash.get';

import {CREATE_INVITE} from 'api/invite';
import {selectInvite} from '../selectors';

const namespace = 'flows/deal/invite';

// Actions
const INVITE = defineAction('INVITE', ['SHOW', 'HIDE'], namespace);
export const showInvite = createAction(INVITE.SHOW);
export const hideInvite = createAction(INVITE.HIDE);

// Selectors
export const selectShowInvite = store => get(selectInvite(store), 'show');
export const selectInviteSending = store => get(selectInvite(store), 'sending');

const initialState = {
  show: false,
  sending: false,
};

export const reducer = handleActions({
  [INVITE.SHOW]: state => ({
    ...state,
    show: true,
  }),
  [INVITE.HIDE]: state => ({
    ...state,
    show: false,
  }),
  [CREATE_INVITE.REQUESTED]: state => ({
    ...state,
    sending: true,
  }),
  [CREATE_INVITE.SUCCESS]: state => ({
    ...state,
    sending: false,
  }),
}, initialState);



// WEBPACK FOOTER //
// ./mobile/shared/flows/deal/invite/reducer.js